<div class="delete-modal-container">
    <p class="modal-message">
      {{ message }}
    </p>
  
    <div class="button-container">
        <ds-button class="empty" [width]="'small'" [styleType]="'empty-main'"  (click)="cancel()" text="INDIETRO"
        ></ds-button>
        <ds-button [width]="'small'" (click)="confirmDelete()" text="CONFERMA"></ds-button>
    </div>
  </div>
  